const production =
  process.env.NODE_ENV === "production" ||
  process.env.ENVIRONMENT === "production";

const environment = process.env.NEXT_PUBLIC_ENVIRONMENT || "development";

const configuration = {
  site: {
    name: "Octolane AI",
    description: "Self Driving AI CRM",
    themeColor: "#ffffff",
    themeColorDark: "#0a0a0a",
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    siteName: "Octolane AI",
    twitterHandle: "octolane_ai",
    githubHandle: "octolane-org",
    convertKitFormId: "",
    locale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
  },
  auth: {
    googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID as string,
  },
  paths: {
    appHome: "/",
  },
  production,
  environment,
  formBaseUrl: process.env.NEXT_PUBLIC_FORM,
  isTestMode: false,
  sentry: {
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  },
  slackInviteLink:
    "https://join.slack.com/t/octolaneai/shared_invite/zt-2ap8yuzsl-K8ccauLB1HkOG0BQA46dKw",

  api: {
    enrichBaseUrl: process.env.NEXT_PUBLIC_ENRICH_API_BASE_URL as string,
    workflowBaseUrl: "https://workflow.octolane.com",
  },
  posthog: {
    apiKey: process.env.NEXT_PUBLIC_POSTHOG_API_KEY,
    apiHost: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
  },
  muixLicenseKey: process.env.NEXT_PUBLIC_MUI_LICENSE_KEY as string,
  bookDemoFormUrl:
    "https://form.octolane.com/df48522e-515f-417b-9faf-d622f4735a75",
  cookieConfig: {
    path: "/",
    sameSite: "strict",
    domain:
      environment === "production"
        ? ".octolane.com"
        : environment === "staging"
          ? ".staging.octolane.com"
          : "localhost",
    secure: environment !== "production" ? false : true,
    httpOnly: environment !== "production" ? false : true,
    accessTokenCookieName: `access_token__${environment}`.replace(
      "__production",
      "",
    ),
    refreshTokenCookieName: `refresh_token__${environment}`.replace(
      "__production",
      "",
    ),
    adminAccessTokenCookieName: `admin_access_token__${environment}`.replace(
      "__production",
      "",
    ),
    adminRefreshTokenCookieName: `admin_refresh_token__${environment}`.replace(
      "__production",
      "",
    ),
    consentCookieName:
      `google_contact_account_autocreation_consent__${environment}`.replace(
        "__production",
        "",
      ),
    consentCookieMaxAge: 1209600, // 2 weeks
    cookieOptions: {
      path: "/",
      sameSite: "lax",
      secure: environment !== "production" ? false : true,
      httpOnly: environment !== "production" ? false : true,
      domain:
        environment === "production"
          ? ".octolane.com"
          : environment === "staging"
            ? ".staging.octolane.com"
            : "localhost",
    },
  },
};

export default configuration;
